import { apiGet } from 'api/api-get'
import { urls } from 'api/api-url'

export const getRegulationList = (token) => {
    return apiGet({
      url: `${urls.regulations.regulations}`,
      token: token
    })
  }